import React from 'react'
import QuotationManagementPage from './quotation-management-page'

const contractPrice = () => {
  return <QuotationManagementPage isPriceContract={true} />
}

export default contractPrice
